import { useState, useEffect } from 'react';
import MarketingCommandCenter from './components/MarketingCommandCenter';
import Login from './components/Login';

const CRM_URL = process.env.REACT_APP_API_URL || 'https://web-production-3713.up.railway.app';

export default function App() {
  // null = checking, false = not authed, true = authed
  const [authed, setAuthed] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) { setAuthed(false); return; }

    // Validate the stored token against the CRM
    fetch(`${CRM_URL}/api/auth/me`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(res => {
        if (res.ok) {
          setAuthed(true);
        } else {
          // Try refresh
          const refreshToken = localStorage.getItem('refreshToken');
          if (!refreshToken) { clearAndLogout(); return; }
          return fetch(`${CRM_URL}/api/auth/refresh`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ refreshToken }),
          }).then(r => r.json()).then(data => {
            if (data.token) {
              localStorage.setItem('token', data.token);
              setAuthed(true);
            } else {
              clearAndLogout();
            }
          });
        }
      })
      .catch(() => setAuthed(true)); // network error — let them try, API calls will fail naturally
  }, []);

  function clearAndLogout() {
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    setAuthed(false);
  }

  if (authed === null) {
    return (
      <div style={{
        minHeight: '100vh', background: '#0a0a0f',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        color: 'rgba(255,255,255,0.3)', fontFamily: 'Inter, sans-serif', fontSize: 13,
      }}>
        Loading...
      </div>
    );
  }

  if (!authed) {
    return <Login onLogin={() => setAuthed(true)} />;
  }

  return <MarketingCommandCenter />;
}
